import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractAnnotationStore } from '../../../../../../outputs/annotation/annotation-shared/state/root/abstract-annotation-store';
import { TaskWorkspaceStore } from '../../../../../h3ml/state/task-workspace-store';
import { getNonFocusedSections } from '../focusable-scrubber/focusable-scrubber.utils';

@Component({
  selector: 'h3-focused-area',
  templateUrl: './focused-area.component.html',
  styleUrls: ['./focused-area.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FocusedAreaComponent extends DirectiveSuperclass {
  nonFocusedSections$: Observable<string[] | undefined>;
  private maxFrameNumber: number;
  private taskWorkspaceStore = inject(TaskWorkspaceStore);

  constructor(
    private store: AbstractAnnotationStore,
    injector: Injector,
  ) {
    super(injector);
    this.maxFrameNumber = this.taskWorkspaceStore.getMaxFrameNumber(
      this.taskWorkspaceStore.state().selectedOutputName,
    );
    this.nonFocusedSections$ = this.store('focusedAreaRange').$.pipe(
      map((range) => getNonFocusedSections(range, this.maxFrameNumber)),
    );
  }
}
